import { Injectable } from '@angular/core';
import { ApiBasic } from '../services/api-basic';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AngularFirestore } from 'angularfire2/firestore';
import { GlobalServiceService } from '../services/global-service.service';
@Injectable({
	providedIn: 'root'
})
export class NotificacionesService {
	private httpOptions = {
		headers: new HttpHeaders(
			{
				'Content-Type': 'application/json',

			}
		)
	}
	appBase:any;
	constructor(
		public http: HttpClient,
		public api: ApiBasic,
		public afs: AngularFirestore,
    public _global: GlobalServiceService
	) {
		// this._global.base_url = this.api.base_url
	}

	public getMaintenanceTodas(user_id, buscar) {
		return this.afs.collection('users').doc(user_id).collection('notifications', ref => ref.where("detalle.region", "==", buscar).orderBy('fecha_creacion', 'desc')).valueChanges()
	}


	public getTotalNotifications(user_id) {
		return this.http.get(this._global.base_url + "/notifications/total?user_id=" + user_id, {})

	}

	public getNotesNotifications(user_id) {
		return this.http.get(this._global.base_url + "/notifications/maintenance/unreadnotes?user_id=" + user_id, {})

	}

	public getReportsNotifications(user_id) {
		return this.http.get(this._global.base_url + "/notifications/reports?user_id=" + user_id, {})

	}

	public getMaintenanceNotifications(user_id) {
		return this.http.get(this._global.base_url + "/notifications/maintenance?user_id=" + user_id, {})

	}

	public getHitoryNotifications(user_id) {
		return this.http.get(this._global.base_url + "/allnotifications?user_id=" + user_id, {})

	}

	public getNumNotifications(user_id, cantidad) {
		return this.http.get(this._global.base_url + "/allnotifications?user_id=" + user_id + "&cantidad=" + cantidad, {})

	}

	public getHistoryNotificationsMaintenance(user_id) {
		return this.http.get(this._global.base_url + "/allnotifications/maintenance?user_id=" + user_id, {})

	}

	public getHistoryNotificationsReport(user_id) {
		return this.http.get(this._global.base_url + "/allnotifications/report?user_id=" + user_id, {})

	}

	public getHistoryNotificationsNotes(user_id) {
		return this.http.get(this._global.base_url + "/allnotifications/notes?user_id=" + user_id, {})

	}

	public deleteAllNotifications(user_id) {
		return this.http.delete(this._global.base_url + "/notifications/deactivatealluser?user_id=" + user_id, {})

	}

	//Notificaciones firebase
	//Traer numero de los activos
	public getTotalNotificationsFirebaseActivoF(user_id) {
		return this.afs.collection('users').doc(user_id).collection('notifications', ref => ref.where('activo', "==", true).orderBy('fecha_creacion', 'desc')).valueChanges()
	}

	//Traer los anteriores
	public getTotalNotificationsFirebaseInactivoF(user_id) {
		// return this.afs.collection('users').doc(user_id).collection('notifications', ref => ref.where('activo', "==", 0).limit(10).orderBy('fecha_creacion','desc')).valueChanges()
		return this.afs.collection('users').doc(user_id).collection('notifications', ref => ref.where('activo', "==", false).limit(10).orderBy('fecha_creacion', 'desc')).valueChanges()

	}

	//Traer los mantenimientos Activos
	public getMaintenanceActiveF(user_id) {
		return this.afs.collection('users').doc(user_id).collection('notifications', ref => ref.where('activo', "==", true).where('typeGroupNotificationId', '==', 2).orderBy('fecha_creacion', 'desc')).valueChanges()
	}

	//Traer los reportes Activos
	public getReportActiveF(user_id) {
		return this.afs.collection('users').doc(user_id).collection('notifications', ref => ref.where('activo', "==", true).where('typeGroupNotificationId', '==', 1).orderBy('fecha_creacion', 'desc')).valueChanges()
	}

	//Traer las notas Activos
	public getNotesActiveF(user_id) {
		return this.afs.collection('users').doc(user_id).collection('notifications', ref => ref.where('activo', "==", true).where('typeGroupNotificationId', '==', 3).orderBy('fecha_creacion', 'desc')).valueChanges()
	}

	//Traer los mantenimientos
	public getMaintenanceF(user_id) {
		return this.afs.collection('users').doc(user_id).collection('notifications', ref => ref.where('typeGroupNotificationId', '==', 2).limit(100).orderBy('fecha_creacion', 'desc')).valueChanges()
	}

	//Traer los reportes
	public getReportF(user_id) {
		return this.afs.collection('users').doc(user_id).collection('notifications', ref => ref.where('typeGroupNotificationId', '==', 1).limit(100).orderBy('fecha_creacion', 'desc')).valueChanges()
	}

	//Traer las notas
	public getNotesF(user_id) {
		return this.afs.collection('users').doc(user_id).collection('notifications', ref => ref.where('typeGroupNotificationId', '==', 3).limit(100).orderBy('fecha_creacion', 'desc')).valueChanges()
	}

	//Traer las notas CONSULTAS
	public getNotesConsultasF(user_id) {
		return this.afs.collection('users').doc(user_id).collection('notifications', ref => ref.where('typeGroupNotificationId', '==', 4).limit(100).orderBy('fecha_creacion', 'desc')).valueChanges()
	}

	//Traer las notas CONSULTAS
	public getRefaccionesF(user_id) {
		return this.afs.collection('users').doc(user_id).collection('notifications', ref => ref.where('typeGroupNotificationId', '==', 5).limit(100).orderBy('fecha_creacion', 'desc')).valueChanges()
	}

	//Cambiar estdado de activo a inactivo solo uno
	updateStatusF(user, idNotification): Promise<any> {
		return new Promise(async (resolve, reject) => {
			this.afs.collection("users").doc(user).collection("notifications").doc(idNotification).update({
				activo: false
			}).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	}

	//Cambiar estdado de activo a inactivo de todos los activos
	updateStatusAllF(user, data): Promise<any> {
		return new Promise(async (resolve, reject) => {
			data.map(async element => {
				this.afs.collection("users").doc(user.toString()).collection("notifications").doc(element.notificacion_id.toString()).update({
					activo: false
				}).then(res => {
					resolve(res)
				}).catch(error => {
					reject(error)
				})
			});

		})
	}

	setUserOnBulkLoad(userId) {

		const userRef = this.afs.collection("users").doc(userId)

		userRef.ref
			.get()
			.then(data => {

				if (Object.keys(data.data()).length === 0) {
					userRef.set({
						isOnBulkLoad: true
					})
				} else {
					userRef.update({
						isOnBulkLoad: true
					})
				}

			})
	}

	setUserOnBulkLoadFalse(userId) {

		const userRef = this.afs.collection("users").doc(userId)

		userRef.ref
			.get()
			.then(data => {

				if (Object.keys(data.data()).length === 0) {
					userRef.set({
						isOnBulkLoad: false
					})
				} else {
					userRef.update({
						isOnBulkLoad: false
					})
				}

			})
	}


	getUser(userId) {
		return this.afs.collection("users")
			.doc(userId)
			.valueChanges()
	}

	resetMessage(userId) {

		this.afs.collection("users")
			.doc(userId)
			.update({
				messageText: ""
			})

	}

	deleteNotificationUser(user, data): Promise<any> {
		return new Promise(async (resolve, reject) => {
			data.forEach(element => {
				this.afs.collection("users").doc(user.toString()).collection("notifications").doc(element.notificacion_id.toString()).delete().then(res => {
					resolve(res)
				}).catch(error => {
					reject(error)
				})
			});

		})
	}
}
